import ModuleHeader from "../components/ModuleHeader/ModuleHeader";
import usePrivateLink from "../config/usePrivateLink";
import LibraryTabs from "./LibraryTabs";

export default function LibraryLayout({ children }) {
  return;
  const hasAccess = usePrivateLink();

  const permittedTabs = LibraryTabs
    .map((tab) => {
      const accessiblePaths = tab.activePaths.filter((route) =>
        hasAccess(route)
      );

      return {
        ...tab,
        path: accessiblePaths[0] || "/",
        access: accessiblePaths.length > 0,
      };
    })
    .filter((tab) => tab.access);

  return (
    <>
      <ModuleHeader tabs={permittedTabs} />
      {children}
    </>
  );
}